<template>
<article v-show="visible" id="loadingBox" class="loading" :style="{'position': type}">   
	<slot></slot> 
</article>
</template>

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			default() { return false }
		},
		type: {
			type: String,
			default() { return 'absolute' }
		}
	},
	data () {
		return {}
	},
	mounted(){
	},
	methods: {

	}
}
</script>
<style lang="scss" scoped>
#loadingBox {
	display: flex; align-items: center; justify-content: center;
	position: absolute; top:0; left:0; right:0; bottom:0;
	opacity: 1; 
	transition-property: opacity; 
	transition-duration: 0.475s; 
	transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
	z-index: 9999;
	// // backdrop-filter: blur( 2px ); 

	&::after {
		content:'';
		display: block; width: 50px; height: 50px;
		background:url('../../assets/image/loading.svg') center no-repeat;
		background-size: 100%;
	}
}
</style>